import { render, staticRenderFns } from "./12PaymentInfo.vue?vue&type=template&id=1cf6f184"
import script from "./12PaymentInfo.vue?vue&type=script&lang=js"
export * from "./12PaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./12PaymentInfo.vue?vue&type=style&index=0&id=1cf6f184&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports